import React from "react";
import PropTypes from "prop-types";

import DialogForm, { DialogFormPropTypes } from "./DialogForm";
import { DialogStepperActions } from "./DialogStepperActions";

import useDialogStepper from "./useDialogStepper";

export function DialogStepper(props) {
  const { steps, onSubmit, ariaLabelledby, ...otherProps } = props;
  const {
    activeStep,
    isLastStep,
    isFirstStep,
    validationSchema,
    renderContent,
    handleBack,
    handleSubmit,
  } = useDialogStepper(steps, onSubmit);

  const renderActions = (onClose, isLoading, preLoading) => (
    <DialogStepperActions
      handleBack={handleBack}
      steps={steps}
      onClose={onClose}
      isLoading={isLoading}
      isFirstStep={isFirstStep}
      isLastStep={isLastStep}
      preLoading={preLoading}
      ariaLabelledby={ariaLabelledby}
    />
  );

  return (
    <DialogForm
      activeStep={activeStep}
      steps={steps}
      renderActionsFunc={renderActions}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      ariaLabelledby={ariaLabelledby}
      {...otherProps}
    >
      {renderContent()}
    </DialogForm>
  );
}

DialogStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      Icon: PropTypes.any,
      renderContent: PropTypes.func,
    }),
  ),
  ...DialogFormPropTypes,
};
